__turbopack_context__.v({
  "panel": "DatePickerCalendar-module__SCFLnq__panel",
  "view": "DatePickerCalendar-module__SCFLnq__view",
  "viewStack": "DatePickerCalendar-module__SCFLnq__viewStack",
  "yearList": "DatePickerCalendar-module__SCFLnq__yearList",
  "yearListViewport": "DatePickerCalendar-module__SCFLnq__yearListViewport",
});
